import { component, prop } from '../../../decorators';

import { START_EPISODE_AT } from '../../../config';

const HEADER_WIDTH = 144;

@component({
   watch: {
      period: 'recalc',
      time: 'recalc',
      parentWidth: 'recalc'
   }
})
export default class WorkplacePosition {
   @prop({ type: Array, default: [] }) period
   @prop({ type: Number, required: true }) time;
   @prop({ type: Number, required: true }) duration;
   @prop({ type: Number, required: true }) timecode;
   @prop({ type: Number, required: true }) leftPosition;
   @prop({ type: Number, required: true }) parentWidth;
   @prop({ type: Function, required: true }) detectScrollLeft;

   atTime = null
   position = null

   recalc() {
      this.position = _position(this.time, this.period, this.parentWidth);
   }

   onMouseMove(e) {
      e.preventDefault();
      e.stopPropagation();
      const [ start, end ] = this.period;
      const x = e.clientX - this.leftPosition - HEADER_WIDTH + this.detectScrollLeft();
      const time = x * ( end - start ) / this.parentWidth;
      this.atTime = time + START_EPISODE_AT;
      this.position = _position(this.atTime, this.period, this.parentWidth);
   }

   onMouseDown(e) {
      e.preventDefault();
      e.stopPropagation();
      document.addEventListener('mousemove', this.onMouseMove);
      document.addEventListener('mouseup', this.onMouseUp);
   }

   onMouseUp() {
      document.removeEventListener('mousemove', this.onMouseMove);
      document.removeEventListener('mouseup', this.onMouseUp);
      this.$emit('change-time-position', this.atTime);
   }

   mounted() {
      this.recalc();
      this.$el.addEventListener('mousedown', this.onMouseDown);
   }

   destroyed() {
      this.$el.removeEventListener('mousedown', this.onMouseDown);
   }
}

function _position(time, [from, to], width) {
   return width * (time - from) / (to - from);
}
